import React, { useState } from 'react';

export default function RenderItem({ option, props }: any) {
    const [loading, setLoading] = useState(true);
    function handleError () {
        setLoading(false)
    }
    return (
        <li {...props} style={{ display: "flex", alignItems: "center", gap: 10 }}>
            {option.logo && loading && option?.logo !== 'init' && (
                <img src={option.logo} alt={option.label} width={24} height={24} style={{ borderRadius: "50%", objectFit: 'contain' }} onError={handleError}/>
            )}
            {option.logo && (!loading || option?.logo === 'init') && (
                <div style={{ display: 'flex', background: '#fff3ed', alignItems: 'center', justifyContent: 'center', height: '26px', width: '26px', borderRadius: '50%' }}>
                    <span style={{ color: '#fa4616', fontSize: '14px', textTransform: 'uppercase' }}>{option.label?.[0] || 0}</span>
                </div>
            )}
            {option.label}
        </li>
    );
}
